import { Button, Divider } from 'antd-mobile';
import { copyText } from '@/utils/index';
import { useEffect } from 'react';
// import { getServicoList } from '@/api/servico';
import BottomBar from '@/components/BottomBar';
import './index.less';
import { useServicoList } from '@/store';

const Servico = () => {
  // 客服列表
  const ServicoList = useServicoList(state => state.list)

  // 获取最新客服列表
  const getAndUpdateList = useServicoList(state => state.getAndUpdateList)
  useEffect(() => {
    getAndUpdateList()
  }, []);

  return (
      <div>
        <div className="servicePopup">
          {ServicoList.map(({ id, avatar, name, account, type }) => {
            return (
              <div className="popItem" key={id}>
                <div className="flex">
                  <div className="flex w-[64px] justify-center">
                    <img
                      className="w-[36px] h-[36px] rounded-[4px] mr-2"
                      src={avatar}
                      alt="telegram"
                    />
                  </div>
                  <div>
                    <span className="truncate max-w-44 text-[15px] leading-[22px] font-bold">{name}</span>

                    <div className="flex h-[32px] text-[12px] pt-1">
                      {/* <img className="w-6 h-6 opacity-45" src={pinglun_bai} alt="" /> */}
                      {type !== 'OnlineCS' && (
                        <span className="truncate max-w-44 mr-1">{type}</span>
                      )}
                      {/* {account && (
                    <Divider direction="vertical" className="!border-[#fff]/10" />
                  )} */}
                      <span
                        className="truncate max-w-44"
                        onClick={() => {
                          switch (type) {
                            case 'Tel':
                              copyText(account);
                              break;
                            case 'Whatsapp':
                              copyText(`https://wa.me/${account}`);
                              break;
                            case 'Instagram':
                              copyText(`https://instagram.com/${account}`);
                              break;
                            case 'Telegram':
                              copyText(`https://t.me/${account}`);
                              break;
                            default:
                              copyText(account);
                              break;
                          }
                        }}
                      >
                        {account}
                      </span>
                    </div>
                    <Button
                      // fill="outline"
                      onClick={() => {
                        switch (type) {
                          case 'Tel':
                            window.location.href = `tel:${account}`;
                            break;
                          case 'Whatsapp':
                            window.open(`https://wa.me/${account}`, '_blank');
                            break;
                          case 'Instagram':
                            window.open(`https://instagram.com/${account}`, '_blank');
                            break;
                          case 'Telegram':
                            window.open(`https://t.me/${account}`, '_blank');
                            break;
                          default:
                            window.open(account, '_blank');
                            break;
                        }
                      }}
                      className="chat"
                    />
                  </div>
                </div>

                <Divider className="!border-[#fff]/10" />
              </div>
            );
          })}

          <BottomBar />
        </div>
      </div>
  );
};

export default Servico;
